var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{on:{"click":_vm.toggleQrScanner}},[(_vm.open)?_c('span',[_c('font-awesome-icon',{staticClass:"icon fa-fw",attrs:{"icon":"times"}})],1):_c('span',[_c('font-awesome-icon',{staticClass:"icon fa-fw",attrs:{"icon":"qrcode"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }